import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";
import { Typography } from "@/components/ui/typography";

export type PressureCyclesPolar = {
  do_you_want_to_design_for_constant_pressure_cycles: PolarYesNoUndefined;
  are_the_expected_cycles_more_than_7000_over_design_life: PolarYesNoUndefined;
};
type PressureCyclesProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof PressureCyclesPolar }) => void;
  polarQuestions: PressureCyclesPolar;
};
export default function PressureCyclesChecks({ onHandleYesNo, polarQuestions }: PressureCyclesProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you want to design for constant pressure cycles"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "do_you_want_to_design_for_constant_pressure_cycles" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "do_you_want_to_design_for_constant_pressure_cycles" });
        }}
        selection={polarQuestions.do_you_want_to_design_for_constant_pressure_cycles}
      />
      <PolarQuestion
        shouldRender={polarQuestions.do_you_want_to_design_for_constant_pressure_cycles === "yes"}
        question="Are the expected pressure cycles more than 7000 over the design life?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "are_the_expected_cycles_more_than_7000_over_design_life" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "are_the_expected_cycles_more_than_7000_over_design_life" });
        }}
        selection={polarQuestions.are_the_expected_cycles_more_than_7000_over_design_life}
      />
      {polarQuestions.are_the_expected_cycles_more_than_7000_over_design_life === "no" && (
        <Typography variant="text-md" weight="semibold" className="text-primary-500">
          Cyclic loading consideration is not required for less than 7000 cycles
        </Typography>
      )}
    </>
  );
}
